import { Component, Input, OnInit } from '@angular/core';
import { WindowRef } from '@ca/core/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ca-share-view-dialog',
    templateUrl: './share-view-dialog.component.html',
    styleUrls: ['./share-view-dialog.component.scss'],
})
export class ShareViewDialogComponent implements OnInit {
    @Input() viewerLink: string;

    private shareViewText: string;

    constructor(
        private modal: NgbActiveModal,
        private translateService: TranslateService,
        private windowRef: WindowRef,
    ) {}

    ngOnInit(): void {
        this.shareViewText = this.translateService.instant('MY_WORKSPACE.MY_FILES.SHARE_VIEW_DIALOG_TITLE');

        // prepend base url, viewerLink does not have it by default
        this.viewerLink = this.viewerLink;
    }

    dismiss(reason: string): void {
        this.modal.dismiss(reason);
    }

    openTwitter(): void {
        const twitterLink: string = `https://twitter.com/share?text=${this.shareViewText}&url=${encodeURIComponent(this.viewerLink)}&hashtags=Apeer`;
        const w = this.windowRef.nativeWindow.open(twitterLink, '_blank', 'width=800,height=500');
        if (w != null) {
            w.focus();
        }
    }

    openEmail(): void {
        this.windowRef.nativeWindow.location.href = `mailto:?body=${this.shareViewText}%0D%0A${encodeURIComponent(this.viewerLink)}`;
    }

    openLinkedIn(): void {
        const link: string = `https://www.linkedin.com/shareArticle?mini=true&summary=${encodeURIComponent(this.shareViewText)}%0D%0A${encodeURIComponent(
            this.viewerLink,
        )}`;
        const w = this.windowRef.nativeWindow.open(link, '_blank', 'width=1200,height=700');
        if (w != null) {
            w.focus();
        }
    }
}
